/*
 * Copyright 2023 Siemens
 */

import React from 'react';
import {
  SwwcButton,
  SwwcLoadingIndicator,
  SwwcPanel,
  SwwcPanelBody,
  SwwcPanelFooter,
} from '@com.siemens.plm.horizon/swwc/bindings/react';

interface PanelProps {
  title: string;

  isEditable?: boolean;
  isDeletable?: boolean;
  isReadOnly: boolean;
  isSubmission: boolean;

  onClose: () => void;
  onDelete?: () => void;
  onEdit?: () => void;
  onSubmitCancel?: () => void;
  onSubmit?: () => void;

  children: React.ReactNode | ReadonlyArray<React.ReactNode>;
}

interface PanelState {}

export class Panel extends React.Component<PanelProps, PanelState> {
  override render() {
    return (
      <SwwcPanel
        headerTitle={this.props.title}
        opened={true}
        uncontrolled-mode={true}
        fullHeightMode={true}
        hideSwitchHeightAction={true}
        pinned={true}
        openDirection={'right-to-left'}
        hideSwitchPinAction={true}
        onPanelClosed={this.props.onClose}
      >
        <SwwcPanelBody>{this.props.children}</SwwcPanelBody>
        <SwwcPanelFooter>
          {this.props.isReadOnly && !this.props.isSubmission ? (
            <React.Fragment>
              {this.props.onDelete && (
                <SwwcButton
                  label='Delete'
                  disabled={this.props.isDeletable === false}
                  onClickEvent={this.props.onDelete}
                ></SwwcButton>
              )}
              {this.props.onEdit && (
                <SwwcButton
                  label='Edit'
                  disabled={this.props.isEditable === false}
                  onClickEvent={this.props.onEdit}
                  variant='accent-high-contrast'
                ></SwwcButton>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {this.props.isSubmission && <SwwcLoadingIndicator i18nLoading='Submitting' />}
              {this.props.onSubmitCancel && (
                <SwwcButton
                  label='Cancel'
                  disabled={this.props.isSubmission}
                  onClickEvent={this.props.onSubmitCancel}
                ></SwwcButton>
              )}
              {this.props.onSubmit && (
                <SwwcButton
                  label='Submit'
                  variant='accent-high-contrast'
                  disabled={this.props.isSubmission}
                  onClickEvent={this.props.onSubmit}
                ></SwwcButton>
              )}
            </React.Fragment>
          )}
        </SwwcPanelFooter>
      </SwwcPanel>
    );
  }
}
